import { useLocation } from 'react-router-dom';
import { Box, ImageList, ImageListItem } from '@mui/material';

import Slider from '~/components/atoms/microsite-images/components/slider/slider';
import { isMobileResolution } from '~/utils/common';

import { getConvertImagesToGrid, MicrositeImageItem, MicrositeImagesType } from './utils';

type MicrositeImagesProps = {
  data: MicrositeImageItem[];
  type: MicrositeImagesType;
};

export default function MicrositeImages({ data, type }: MicrositeImagesProps) {
  const location = useLocation();
  const isMicrosite = location.pathname.startsWith('/s/');

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {type === 'VERTICAL' ? (
        <Slider data={data} isMicrosite={isMicrosite} />
      ) : (
        <ImageList
          sx={{
            width: isMobileResolution ? '100%' : 212,
            overflow: 'visible',
          }}
          variant="quilted"
          gap={8}
          cols={4}
        >
          {getConvertImagesToGrid(data, type).map((item) => (
            <ImageListItem key={item.img || item?.image} cols={item.cols || 1} rows={item.rows || 1}>
              <img
                src={item.img || item?.image}
                style={{
                  display: item.img || item?.image ? 'block' : 'none',
                  borderRadius: 10,
                  width: '100%',
                  height: isMobileResolution
                    ? isMicrosite
                      ? 105 * item.rows
                      : 65 * item.rows
                    : item.height
                      ? item.height
                      : 55 * item.rows,
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
                alt={item.title}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      )}
    </Box>
  );
}
